import apiClient from './apiClient.js';

const MATERIALES_ENDPOINT = '/materiales/';

const materialsService = {
    async createMaterial(materialData) {
        const response = await apiClient.post(MATERIALES_ENDPOINT, materialData);
        return response.data;
    },
    async getMaterialsByProveedor(idProveedor) {
        const url = `${MATERIALES_ENDPOINT}?id_proveedor=${idProveedor}`;

        try {
            const response = await apiClient.get(url);
            return response.data;
        } catch (error) {
            console.error("Error en getMaterialsByProveedor:", error);
            throw error;
        }
    },

    async updateMaterial(idMaterial, updateData) {

        const response = await apiClient.patch(`/materiales/${idMaterial}/`, updateData);
        return response.data;
    },
    getAllMateriales() {
        return apiClient.get(MATERIALES_ENDPOINT);
    },

    getPaneles() {
        return apiClient.get('/paneles/');
    },

    getInversores() {
        return apiClient.get('/inversores/');
    },
getMaterialesElectricos() {
        return apiClient.get(`${MATERIALES_ENDPOINT}?tipo_proveedor=Electrico`);
       
    }

}

export default materialsService;